import React from "react";
import { Navigate } from "react-router-dom";
import { useUiPack } from "@/hooks/useUiPack";
import SimpleSettingsHub from "@/pages/simple/SimpleSettingsHub";

export default function UiPackAdminHub() {
  const { isSimple } = useUiPack();
  if (!isSimple) return <Navigate to="/admin/general" replace />;
  return <SimpleSettingsHub />;
}
